import Model from './model';

export default class Skill extends Model {
  static NAME = 'skill';
  static COLLECTION_NAME = "skills";
  static URL = '/api/v2/skills';

  static PLATFORM_CATEGORY_SUGGESTIONS = [
    'Adobe Experience Manager',
    'AWS',
    'Azure',
    'Cognos',
    'eCommerce',
    'IBM DataStage',
    'IFS',
    'JD Edwards',
    'Maximo',
    'Microsoft',
    'Microsoft Dynamics',
    'NetSuite',
    'OpenText',
    'Oracle EBS',
    'PeopleSoft',
    'Salesforce',
    'SAP',
    'ServiceNow',
    'Siebel',
    'SiteCore',
    'Workday',
  ]
}